module.exports = __webpack_public_path__ + "img/active-layer4.499fc224.png";